import { Card, Typography, Grid, TextareaAutosize, Box, IconButton, DialogTitle, DialogContent, DialogContentText, Dialog, DialogActions } from '@mui/material';
import { useState, useEffect, useRef, useCallback } from 'react';
import styles from '../managePolicies/managePolicies.module.scss';
import { CustomEditIcon, CustomDeleteIcon, CommonButton, CommonOutlinedButton } from '../../common/StyledComponents/StyledFields';
import VendorsForm from './vendorsForm';
import tablestyles from '../../devoteeService/devoteeService.module.scss';
import updateIcon from '../../../assets/svg/update_outline.svg';
import deleteIcon from '../../../assets/svg/delete_outline.svg';
import { apiRequest, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import ErrorPopup from '../../common/ErrorPopup';
import constants from '../../../config/constants.json';
import toast from 'react-hot-toast';
import Pagination from "../../common/pagination/pagination";
import CloseIcon from '@mui/icons-material/Close';
import commonStyles from '../../../App.module.scss';
import apiPath from '../../../config/apiPaths.json';
import ButtonLoader from '../../common/ButtonLoader/ButtonLoader';
import { useReactToPrint } from 'react-to-print';
import PrintTreasuryReports from '../../reportSection/treasury/PrintTreasuryReports';


interface vendorsId {
    id: string;
}

const DataEntryVendors = () => {
    const tableRef = useRef(null);
    const [isAdding, setIsAdding] = useState(false);
    const [vendorsList, setVendorsList] = useState<vendorsId[]>([])
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
    const [selectedSpecialId, setSelectedActivityId] = useState<any | null | undefined>(null);
    const [selectData, setSelectData] = useState<any>([]);
    const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
    const [loading, setLoading] = useState(false);
    const [printBtnLoading, setPrintBtnLoading] = useState(false);
    const [printColumnData, setPrintColumnData] = useState({});
    const [printData, setPrintData] = useState<any>(null);
   
    const [isPrintTriggered, setIsPrintTriggered] = useState(false);

    const handleAddNewClick = () => {
        setSelectData("");
        setIsAdding((pv) => !pv);
    };
    const handleClose = () => {
        setIsOpen(false);
        setIsOpenDialog(false);
        setSelectedId(null);
        setSelectedActivityId(null);
    };

    const handleDeleteVendors = () => {
        deleteVendorsApiCall();
    };
    const deleteVendorsApiCall = () => {
        apiRequest({
            method: 'DELETE',
            endpoint: `${apiPath.templeVendors}/${selectedSpecialId}`,
            includeToken: true,
        })
            .then((res) => {
                console.log(res.data)
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const PrintStyles = `
    @page {
         size: tabloid;
         margin: 24px;
       }  
       /* Set layout to Landscape */
       body {
         width: '40vw';
         position: absolute;
       }
     @media print {
       .printable {
         display: block !important;
       }
     }
   `;
     const PrintRef = useRef<any>(null);
   
     const handlePrint = useReactToPrint({
       content: () => PrintRef.current,
       documentTitle: "Print Document",
       suppressErrors: true,
       pageStyle: PrintStyles,
     });
     useEffect(() => {
       if (isPrintTriggered && printData.length > 0 && printData.length < 15000) {
         handlePrint();      
         setIsPrintTriggered(false);
       }else if(printData && printData.length > 15000){
         // alert('Print Limit is exceeded, Please use Export to Excel')
         toast.custom(
           <ErrorPopup
             headerTitle="Attention"
             showMessage="Print Limit is exceeded, Please use Export to Excel"
             isOpen={isOpen}
             setIsOpen={setIsOpen}
           />,
           {
             duration: constants.TOAST_POPUP_DURATION,
           }
         );
         setPrintData([])
       }else{
         setPrintData([])
       }
     }, [printData, isPrintTriggered,handlePrint]);
   
     useEffect(()=>{
       setPrintData(printData)
     },[printData])
    useEffect(() => {
        vendorrGetApiCall();
    }, [pageNumber]);

    const vendorrGetApiCall = () => {
        apiRequest({
            method: 'GET',
            endpoint: "/temple/vendors",
            params: {
                page: pageNumber - 1,
                size: 20,
                direction: "asc",
            },
            includeToken: true
        })
            .then((res) => {
                setTotalRecords(res.data.totalElements);
                setVendorsList(res.data.content);
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                });
            });
    }
    const handleAgree = () => {
        if (selectedSpecialId !== null && vendorsList && vendorsList) {
            // Find the index of the item with the selected ID in the roles array
            const indexToRemove = vendorsList.findIndex(
                (item: vendorsId) => item.id === selectedSpecialId,
            );
            handleDeleteVendors();
            if (indexToRemove !== -1) {
                // Create a copy of the roles array without the selected item
                const updatedList = [...vendorsList];
                updatedList.splice(indexToRemove, 1);
                // Update the roles list
                setVendorsList(updatedList);
            }
        }
        // Close the dialog
        handleClose();
    };
    const dialogPopup = () => {
        return (
            <Dialog
                open={isOpenDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        height: 'calc(100% - 128px)',
                        width: 'calc(100% - 128px)',
                        margin: '64px',
                        maxWidth: '504px',
                        maxHeight: '180px',
                        overflowY: 'unset',
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                    },
                }}
            >
                <DialogTitle className={commonStyles.dialogTitle}>
                    {'Please Confirm'}

                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 24,
                            top: 12,
                            color: (theme: any) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon sx={{ color: 'white' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-slide-description"
                        className={commonStyles.dialogContext}
                    >
                        Are You Sure want to remove the Vendor?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
                    <CommonButton onClick={handleAgree}>Yes</CommonButton>
                </DialogActions>
            </Dialog>
        );
    };

    const handleGetVendorsData = (data: any) => {
        setSelectData(data);
        setSelectedActivityId(data?.id);
        setIsAdding(true);
    };
    const openConfirmPopUp1 = (id: number | undefined | null) => {
        setSelectedActivityId(id);
        setIsOpenDialog(true);
    };
    const handleBackAdd = () => {
        setIsAdding(false);
        vendorrGetApiCall();
    };

    const tableData = () => {
        return (
            <Box>
                <table className={tablestyles.tableContainer}>
                    <thead>
                        <tr className={tablestyles.headerTableRow}>
                            <th className={tablestyles.tableHorizontal}>Vendor Name</th>
                            <th className={tablestyles.tableHorizontal}>Address</th>
                            <th className={tablestyles.tableHorizontal}>Action</th>
                        </tr>
                    </thead>
                    <tbody className={tablestyles.tableBody} id="searchData">
                        {vendorsList.map((row: any, id: number) => (
                            <tr key={id} className={tablestyles.tableRow}>
                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        color: '#000',
                                        fontWeight: 400,
                                        textAlign: 'start',
                                        paddingLeft: '21px',
                                    }}
                                >
                                    {row.vendorName}
                                </td>
                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        color: '#000',
                                        fontWeight: 400,
                                        textAlign: 'start',
                                    }}
                                >
                                    {row.address} ,{row.city}, {row.state}, {row.zipcode}
                                </td>
                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        fontWeight: 400,
                                        color: '#000',
                                        textAlign: 'start',
                                        display:"flex"
                                    }}
                                >

                                    <img src={updateIcon} onClick={() => handleGetVendorsData(row)} style={{cursor:"pointer"}}/>
                                    <img src={deleteIcon} onClick={() => openConfirmPopUp1(row?.id)} style={{cursor:"pointer"}}/>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {totalRecords > 20 ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            marginRight: '10px',
                            marginTop: '3px',
                            float: 'right',
                        }}
                    >
                        <Pagination
                            items={totalRecords}
                            itemsPerPage={20}
                            setPageNumber={setPageNumber}
                            pageNumber={pageNumber}
                        />
                    </div>
                ) : (
                    ''
                )}
            </Box>
        );
    };
    const tableDataPrint = () => {
        return (
            <Box>
                <table className={tablestyles.tableContainer}>
                    <thead>
                        <tr className={tablestyles.headerTableRow}>
                            <th className={tablestyles.tableHorizontal}>Vendor Name</th>
                            <th className={tablestyles.tableHorizontal}>Address</th>
                        </tr>
                    </thead>
                    <tbody className={tablestyles.tableBody} id="searchData">
                        {printData.map((row: any, id: number) => (
                            <tr key={id} className={tablestyles.tableRow}>
                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        color: '#000',
                                        fontWeight: 400,
                                        textAlign: 'start',
                                        paddingLeft: '21px',
                                    }}
                                >
                                     {row["Vendor Name"]}
                                </td>
                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        color: '#000',
                                        fontWeight: 400,
                                        textAlign: 'start',
                                    }}
                                >
                                    {row.Address}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>
        );
    };
    const handleExportAndPrint = async () => {
        await convertToPrint();
        setIsPrintTriggered(true);
    };
    const convertToPrint = useCallback(async () => {
        try {
            setPrintBtnLoading(true);
            const res = await apiRequest({
                method: "GET",
                endpoint: `${apiPath.vendorReport}/VENDOR_REPORTS`,
                params: {
                    pageNumber: 0,
                    pageSize: 10000,
                },
                includeToken: true,
            });
            setPrintData(res.data.data);
            let columnHeaders = res.data.data[0];
            let columns :any = {};
            for (let key of Object.keys(columnHeaders)) {
                columns[key] = key;
            }
            setPrintColumnData(columns);
            setPrintBtnLoading(false);
        } catch (error) {
            setPrintBtnLoading(false);
            console.error('Error downloading Excel file:', error);
        }
    }, []);

    const ExportToExcel = async () => {
        try {
            setLoading(true);
            const response = await apiRequest({
                method: "POST",
                endpoint: `${apiPath.vendorReport}/VENDOR_REPORTS/createSheet`,
                params: {
                    pageNumber: 0,
                    pageSize: 10000,
                },
                includeToken: true,
                responseType: 'arraybuffer'
            });
    
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.download = 'vendor report.xlsx';
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error downloading Excel file:', error);
        }
    };
    

const vendors = () => {
    return !isAdding ? (
        <div>
            <div className={styles.subContainer}>
                <Typography className={styles.header} style={{ fontSize: "20px" }}>Vendors</Typography>
                <Grid container sx={{ justifyContent: "flex-end", gap: "5px", margin: "0 auto" }}>
                    <CommonButton className={styles.addnewButton} onClick={handleAddNewClick}>Add New</CommonButton>
                    <CommonOutlinedButton onClick={handleExportAndPrint} className="no_print"
                        disabled={printBtnLoading || vendorsList.length === 0}>
                        <ButtonLoader
                            isBtnLoading={printBtnLoading}
                            btnText={"Print"}
                        />
                    </CommonOutlinedButton>
                    <CommonButton
                        style={{ whiteSpace: "nowrap" }}
                        onClick={ExportToExcel}
                        disabled={loading || vendorsList.length === 0}
                        className="no_print"
                    >
                        <ButtonLoader
                            isBtnLoading={loading}
                            btnText={"Export To Excel"}
                        />
                    </CommonButton>
                </Grid>
            </div>
            <div className={styles.tableContainer}>
                {tableData()}
            </div>
            <div ref={PrintRef}>
                {printData && printData.length > 0 && 
                <div className="printable" style={{ display: 'none' }}>
                     {tableDataPrint()}
                </div>}
            </div>
        </div>
    ) : (
        <>
            <VendorsForm selectData={selectData} handleBack={handleBackAdd} />
        </>
    )
}
return (
    <div style={{ display: "flex" }}>
        <div className={styles.mainContainer} style={{ marginLeft: "0px" }}>
            {vendors()}
            {dialogPopup()}
            {printData && printData.length > 0 && <div className="printable" style={{ display: 'none' }}>
              <PrintTreasuryReports
                tableHeaders={printColumnData}
                ReportData={printData}
              />
            </div>}
        </div>
    </div>
)
}

export default DataEntryVendors;
